import script from "./CreateNewAssements.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateNewAssements.vue?vue&type=script&setup=true&lang=js"

import "./CreateNewAssements.vue?vue&type=style&index=0&id=d89979c4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d89979c4"]])

export default __exports__